import React from 'react';
import { Text } from '@chakra-ui/react';
import { StyledList } from './StyledList';

interface Props {
  items: string[];
}

export const ProductSpecs = React.memo(({ items }: Props) => {
  return (
    <React.Fragment>
      <Text
        mt={6}
        fontWeight="bold"
        fontSize={{ base: 18, md: 20, lg: 24 }}
        color="orange.700"
      >
        規格
      </Text>
      <StyledList items={items} />
    </React.Fragment>
  );
});
